import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import DeliveryMethodService from "../../src/Services/DeliveryMethod.service";
const DeliveryMethodLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "method",
        fetchItemsById: (ids) => {
            return DeliveryMethodService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return DeliveryMethodService.searchAll(search);
        },
        optionRenderer: function optionRenderer(deliveryMethod) {
            return _jsx("span", { children: deliveryMethod.method });
        },
    });
};
export default DeliveryMethodLookup;
